export default "__VITE_ASSET__5EEqBDSw__"